import { apiPath } from '../../constants';
import { addSuccessMessage }  from 'actions';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const TEAM_DELETE_REQUEST = 'DELETE_TEAM_REQUEST';
export const TEAM_DELETE_FAILURE = 'DELETE_TEAM_FAILURE';
export const TEAM_DELETE_SUCCESS = 'DELETE_TEAM_SUCCESS';

export const deleteTeam = (id) => {
    const params = [];
    params['id'] = id;
    return function(dispatch) {
        dispatch(deleteRequest());
        return axios(apiRequestOptions(apiPath.TEAM.DELETE, null, {params}))
            .then(transformHttpResponse)
            .then(response => {
                dispatch(deleteSuccess(id));
                dispatch(addSuccessMessage('Team successfully deleted'));
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(deleteFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const deleteRequest = () => {
    return {
        type: TEAM_DELETE_REQUEST,
    }
};

const deleteFailure = (error) => {
    return {
        type: TEAM_DELETE_FAILURE,
        error,
    }
};

const deleteSuccess = (team) => {
    return {
        type: TEAM_DELETE_SUCCESS,
        team,
    }
};